/* global angular, $, TweenMax, Expo */
angular.module('ua5App')
    .directive('menu', [function() {
        return {
            restrict: 'A',
            templateUrl: 'components/menu/menu.html',
            require: '^globalHeader',
            link: function($scope, element, attrs, globalHeaderCtrl) {
                var $$menu;
                var menuAnimation;
                var today;
                $$menu = $(element).find('.menu');
                $scope.$on('globalHeader:menu:opened', function() {
                    globalHeaderCtrl.toggleMenuOpen();
                    menuAnimation = TweenMax.to($$menu, 0.75, {
                        y: 0,
                        ease: Expo.easeInOut,
                        onStart: function() {
                            // Necessary so that dropshadow doesn't show at
                            // the top of the page before the menu is revealed
                            TweenMax.set($$menu, {
                                alpha: 1
                            });
                        },
                        onReverseComplete: function() {
                            $scope.$apply(function() {
                                globalHeaderCtrl.toggleMenuOpen();
                            });
                            TweenMax.set($$menu, {
                                alpha: 0
                            });
                        }
                    });
                });
                today = new Date();
                $scope.year = today.getFullYear();
                $scope.$on('globalHeader:menu:closed', function() {
                    menuAnimation.reverse();
                });
                $scope.$on('globalHeader:logo:clicked', function() {
                    if (globalHeaderCtrl.menuOpen) {
                        menuAnimation.reverse();
                    }
                });
                // Close menu when state changes
                $scope.$on('$stateChangeStart', function() {
                    if (globalHeaderCtrl.menuOpen) {
                        menuAnimation.reverse();
                    }
                });
                // Close menu when clicked outside
                $scope.$on('app:clicked', function(e, target) {
                    if ($(target).parents('.menu').length === 0 && $(target).parents('.global-header').length === 0) {
                        if (globalHeaderCtrl.menuOpen) {
                            menuAnimation.reverse();
                        }
                    }
                });
            }
        };
    }])
;
